import { MuiColorInput } from 'mui-color-input';
import { SettingsInputProps } from './SettingsInputProps';
import { sharedColors } from '../../../utils/Style';

export const ColorSettingsInput = (props: SettingsInputProps) => {
  return (
    <MuiColorInput
      format='hex'
      size='small'
      fullWidth
      value={props.value?.stringValue ?? sharedColors.primary}
      onChange={(newValue) => props.onChange({ stringValue: newValue })}
    />
  );
};
